import { Component, OnInit } from '@angular/core';

import { UserProvider } from '../../providers/user/user';
import { UserData } from '../../providers/local/user-data';
import { TransactionProvider } from '../../providers/transaction/transaction';
import { IonicAngularProvider } from '../../providers/ionic-angular/ionic-angular';

import * as _ from 'lodash';

@Component({
  selector: 'app-balances',
  templateUrl: './balances.component.html',
  styleUrls: ['./balances.component.css']
})
export class BalancesComponent implements OnInit {


  

  operators:any = [];

  selectedAccountId: any;

  movementTypeList: any = [];

  balance: any = {
    income: {
      total: 0,
      payment: 0,
      transfer: 0
    },
    expenses: {
      total: 0,
      loan: 0,
      expense: 0,
      transfer: 0
    }
  };


  constructor(
    
    public userWS: UserProvider,
    public userData: UserData,
    public transactionWS: TransactionProvider,
    public IA: IonicAngularProvider) {
  }

  ngOnInit() {
    
    this.selectedAccountId = this.userData.user.accountId;
    this.initializeView();


   

  }

  initializeView() {
    this.IA.showLoading();
    return this.transactionWS.getTransactionTypeList()
    .then((res: any) => {
      if(res.status == 'success' && res.data) {
        this.movementTypeList = res.data;
        _.remove(this.movementTypeList, { id: 4});
        if(this.userData.user.roleId > 2) {
          _.remove(this.movementTypeList, { id: 8});
        }
      }

      return this.userWS.managedByCurrentUser();
    })
    .then((res: any) => {
     if(res.status == 'success') {
        this.operators = res.data;
      }

      return this.loadBalanceByID(this.selectedAccountId);
    });
  }

  doRefresh(refresher) {
    this.initializeView()
    .then(() => {
      refresher.complete();

    });

    setTimeout(() => {
      refresher.complete();
    }, 20*1000);
  }

  openDetails() {
    /*this.navCtrl.push('AccountHistoryPage', {
      isToday: true,
      id: this.selectedAccountId
    });*/
    console.log("Opena Details")
  }

  openTransactionForm(type) {

    let data: any = {
      movementType: type
    };

    if(this.userData.user.roleId > 2 && type == 2) {
      data.refAccount = this.userData.user.supervisedBy.account; //destino
      data.account = this.userData.user.account; //origen
    } else if(this.userData.user.roleId > 2 && type == 6) {
      data.account = this.userData.user.account; //origen
    } else if( type == 6 || type == 8) {
      data.accountId = this.userData.user.account.id;
    }

    console.log('Open Transaction PAge',data);
    //this.navCtrl.push('TransactionFormPage', data);
    
  }

  selectTransactionType() {
    let buttons = [];
    this.movementTypeList.map((item) => {

      if(item.id != 8 || this.userData.user.roleId < 3) {
        buttons.push({
          text: item.title,
          handler: () => {
            this.openTransactionForm(item.id);
          }
        });
      }
    });
    buttons.push({
      text: 'Cancelar',
      role: 'cancel',
    });

    /*let actionSheet = this.actionSheetCtrl.create({
      title: 'Selecciona el tipo de transferencia',
      buttons: buttons,
    });
    actionSheet.present();*/

    console.log('New Transaction');

  }

  loadBalanceByID(id) {

    let current = _.find(this.operators, { id: id});
    this.IA.showLoading();
    this.balance = {
      income: {
        total: 0,
        payment: 0,
        transfer: 0
      },
      expenses: {
        total: 0,
        loan: 0,
        expense: 0,
        transfer: 0
      },
      currentBalance: 0
    }
    if(current && current.balance) {
      this.balance.currentBalance = current.balance;
    }
    return this.transactionWS.getAllTodayByAccount( id)
    .then((res: any) => {
      if(res.status="success" && res.data) {
        let tracking;
        res.data.map((item) => {
          tracking = false;
          switch (item.movementType) {
            case 4:
              this.balance.income.payment += item.amount;
              tracking = true;
            break;
            case 2:
              if(item.transactionType == 1) {
                this.balance.income.transfer += item.amount;
                tracking = true;
              } else if(item.transactionType == 2) {
                this.balance.expenses.transfer += item.amount;
                tracking = true;
              }
            break;
            case 3:
              this.balance.expenses.loan += item.amount;
              tracking = true;
            break;
            case 6:
            case 8:
              this.balance.expenses.expense += item.amount;
              tracking = true;
            break;

          }

          if(tracking) {
            if(item.transactionType == 1) {
              this.balance.income.total += item.amount;
            } else if(item.transactionType == 2) {
              this.balance.expenses.total += item.amount;
            }
          }
          
        });
      }
      return res;
    })
    .then(()=> {
      this.IA.hideLoading();
    });
  }

}



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/pages/balances/balances.component.ts